import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

//
import { Col } from "react-bootstrap";
import { useTable, useSortBy } from "react-table";
import Moment from "react-moment";

//
import { getTransactions } from "../../../redux/features/plan/actions";

//
import ReactTable from "../../general/ReactTable";
import BoxLoading from "../../general/BoxLoading";

function Transactions({plan}) {
  const [key, setKey] = useState(0);
  const [loading, setLoading] = useState(false);

  //
  const [transactions, setTransactions] = useState([]);

  const convertStatusColor = (status) => {
    if (status === "pending") return "warning";
    if (status === 'canceled') return 'danger'
    return "success";
  };

  /**
   * Get Transactions
   */
  const get_transactions = async () => {
    // start loading
    setLoading(true);

    // request
    await getTransactions().then((res) => {
      if (res) {
        setTransactions(res);
        setKey(key + 1);
      }
    });

    // stop loading
    setLoading(false);
  };

  useEffect(() => {
    get_transactions();

    // eslint-disable-next-line
  }, [plan]);

  // begin::table
  const data = transactions;

  const columns = React.useMemo(
    () => [
      {
        Header: "description",
        accessor: "description", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let value = cellProps.value;

          return (
            <div className="d-flex align-items-center">
              <i className="las la-arrow-right text-success"></i>
              <small className="text-black fw-bolder">{value}</small>
            </div>
          );
        },
      },
      {
        Header: "Date",
        accessor: "created_at", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let value = cellProps.value;
          return (
            <small>
              <span className="fw-extra-bolder text-black">
                <Moment utc format="MMM DD, YYYY, ">{value}</Moment>
              </span>
              <span>
                <Moment utc format="hh:mm">{value}</Moment>
              </span>
            </small>
          );
        },
      },
      {
        Header: "Amount",
        accessor: "amount", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let value = cellProps.value;

          return <small className="text-black fw-bolder">${value}</small>;
        },
      },
      {
        Header: "status",
        accessor: "status", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let value = cellProps.value;

          return (
            <small className={`fw-bolder text-${convertStatusColor(value)}`}>
              {value}
            </small>
          );
        },
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data }, useSortBy);
  // end::table

  return (
    <Col md={6} xl={8} className="transactions">
      <p className="title">Transaction History</p>

      <ReactTable
        key={key}
        rows={rows}
        sort
        sticky
        tableHeigth='448'
        prepareRow={prepareRow}
        headerGroups={headerGroups}
        getTableProps={getTableProps}
        getTableBodyProps={getTableBodyProps}
      />

      {loading && <BoxLoading/>}
    </Col>
  );
}

Transactions.propTypes = {
  plan: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  plan: state.userReducer.plan,
});

export default connect(mapStateToProps)(Transactions);
